import { useState, useEffect } from 'react';
import { portalApi } from '../services/portalApi';

const FALLBACK: [number, number] = [-33.9249, 18.4241]; // Cape Town CBD

function fromLocalStorage(): [number, number] | null {
  try {
    const raw = localStorage.getItem('patrolit-default-centre');
    if (raw) {
      const parsed = JSON.parse(raw) as [number, number];
      if (Array.isArray(parsed) && parsed.length === 2) return parsed;
    }
  } catch { /* ignore */ }
  return null;
}

/**
 * Returns the estate's default map centre.
 * Initialises from localStorage for instant render, then fetches from the
 * estate API (authoritative — saved by admin in Settings). Updates the map
 * once the API responds, and caches the result in localStorage for next load.
 */
export function useDefaultCentre(): [number, number] {
  const [centre, setCentre] = useState<[number, number]>(
    fromLocalStorage() ?? FALLBACK,
  );

  useEffect(() => {
    portalApi.getEstate()
      .then((estate) => {
        if (estate.default_lat != null && estate.default_lng != null) {
          const c: [number, number] = [estate.default_lat, estate.default_lng];
          setCentre(c);
          localStorage.setItem('patrolit-default-centre', JSON.stringify(c));
        }
      })
      .catch(() => {});
  }, []);

  return centre;
}
